import { v4 as uuidv4 } from 'uuid';

/**
 * Session Manager for Anonymous Users
 * Manages session IDs for tracking anonymous users before they identify themselves
 */

const SESSION_KEY = 'anonymous_session_id';
const SESSION_CREATED_KEY = 'session_created_at';

export class SessionManager {
  constructor() {
    this.sessionId = this.getOrCreateSessionId();
  }

  /**
   * Get existing session ID or create a new one
   */
  getOrCreateSessionId() {
    let sessionId = localStorage.getItem(SESSION_KEY);
    
    if (!sessionId) {
      sessionId = this.generateSessionId();
      localStorage.setItem(SESSION_KEY, sessionId);
      localStorage.setItem(SESSION_CREATED_KEY, new Date().toISOString());
    }
    
    return sessionId;
  }

  /**
   * Generate a new unique session ID
   */
  generateSessionId() {
    return `anon_${uuidv4()}_${Date.now()}`;
  }

  /**
   * Get current session ID
   */
  getCurrentSessionId() {
    return this.sessionId;
  }

  /**
   * Clear session (when user identifies themselves)
   */
  clearSession() {
    localStorage.removeItem(SESSION_KEY);
    localStorage.removeItem(SESSION_CREATED_KEY);
    this.sessionId = null;
  }

  /**
   * Check if session exists and is valid
   */
  hasValidSession() {
    const sessionId = localStorage.getItem(SESSION_KEY);
    const createdAt = localStorage.getItem(SESSION_CREATED_KEY);
    
    if (!sessionId || !createdAt) {
      return false;
    }
    
    // Session expires after 30 days
    const sessionAge = Date.now() - new Date(createdAt).getTime();
    const thirtyDays = 30 * 24 * 60 * 60 * 1000;
    
    return sessionAge < thirtyDays;
  }

  /**
   * Refresh session timestamp
   */
  refreshSession() {
    if (this.sessionId) {
      localStorage.setItem(SESSION_CREATED_KEY, new Date().toISOString());
    }
  }
}

// Create singleton instance
const sessionManager = new SessionManager();

export default sessionManager; 